/* Wolfborn place names v3: one line = one piece; plain-text order attachment.
   Private properties hide long lists from checkout, not from the cart API. */
(function (global) {
  'use strict';
  const CONFIRMATION = 'Spelling and capitalisation checked; no proof supplied';
  const NAMES_KEY = '_Guest names', FILE_KEY = '_Guest list TXT';
  function names(raw) {
    return String(raw == null ? '' : raw).split(/\r\n|[\n\r\u2028\u2029]/).map(s => s.trim()).filter(Boolean);
  }
  function inspect(raw) {
    const list = names(raw);
    let error = '';
    if (list.length < 4) error = 'Please enter at least four guest names, one guest per line.';
    else if (list.some(s => /[,;\t\x00-\x1f]/.test(s))) error = 'Use a separate line for each guest, not commas, semicolons or tabs.';
    else if (list.some(s => /^\d+[.)]\s/.test(s))) error = 'Please remove the numbering from your guest list.';
    return {names:list, count:list.length, text:list.join('\n'), error, ok:!error};
  }
  function band(count,size) { if(String(size||'').startsWith('50–60'))return count>=50?'50+ names':count>=10?'10–49 names':'4–9 names'; return count >= 26 ? '26+ names' : count >= 10 ? '10–25 names' : '4–9 names'; }
  function quotation(raw, material, variants, size) {
    const result = inspect(raw);
    const variant = (variants || []).find(v => v.material === material && v.band === band(result.count,size) && (!v.size || v.size === size));
    const price = variant && Number(variant.price);
    if (!variant || !Number.isSafeInteger(price) || price < 0) return {...result,ok:false,error:'This material or price is unavailable. Please refresh the page.',variant:null};
    const total = result.count * price;
    if (!Number.isSafeInteger(total)) return {...result,ok:false,error:'This guest list exceeds the order limit.',variant:null};
    return {...result,variant,unit:price,total,band:band(result.count,size)};
  }
  function payload(raw, material, config, confirmed, listId, size) {
    const q = quotation(raw,material,config.variants,size);
    if (!q.ok) throw new Error(q.error);
    if (!confirmed) throw new Error('Please check your spelling and capitalisation, then tick the confirmation.');
    if (!q.variant.available) throw new Error('This material is currently unavailable.');
    const id = Number(q.variant.id);
    if (!Number.isSafeInteger(id) || id <= 0 || !listId) throw new Error('The order option could not be verified. Refresh the page.');
    return {items:[{id,quantity:q.count,properties:{
      [NAMES_KEY]:q.text, 'Guest list':q.count+' names supplied',
      ...(size ? {'Name size':size} : {}), 'Font style':config.font, 'Material / finish':material, 'Material thickness':'3 mm',
      'Spelling confirmation':CONFIRMATION, '_wb_place_names':'v3', '_wb_list_id':listId
    }}]};
  }
  function textFile(raw, font, listId) {
    const r = inspect(raw); if (!r.ok) throw new Error(r.error);
    const safe = s => String(s || '').normalize('NFKD').replace(/[^a-zA-Z0-9_-]+/g,'-').replace(/^-+|-+$/g,'').slice(0,48);
    const filename = 'wolfborn-'+(safe(font)||'place-names')+'-'+r.count+'-names-'+(safe(listId)||'copy')+'.txt';
    // UTF-8, Windows-friendly newlines, no heading, numbering, sorting or deduplication.
    return new File([r.names.join('\r\n')+'\r\n'],filename,{type:'text/plain;charset=utf-8'});
  }
  function uploadData(body) {
    const item = body && body.items && body.items[0];
    if (!item || body.items.length !== 1) throw new Error('One guest list must be submitted at a time.');
    const p = item.properties, r = inspect(p[NAMES_KEY]);
    if (!r.ok || r.count !== item.quantity) throw new Error('The guest list and quantity do not match.');
    const data = new FormData(); data.append('id',String(item.id)); data.append('quantity',String(item.quantity));
    Object.entries(p).forEach(([key,value]) => data.append('properties['+key+']',String(value)));
    const file = textFile(r.text,p['Font style'],p._wb_list_id);
    data.append('properties['+FILE_KEY+']',file,file.name);
    return data;
  }
  function itemNames(item) {
    const p = item.properties || {};
    return typeof p[NAMES_KEY] === 'string' ? p[NAMES_KEY] : p['Guest names'];
  }
  function storedFileUrl(raw) {
    if (typeof raw !== 'string' || !raw.trim() || !/^(https:\/\/|\/)/.test(raw)) return false;
    try {
      const u = new URL(raw,'https://wolfbornstudio.com');
      return u.protocol === 'https:' && !u.username && !u.password &&
        ['cdn.shopify.com','wolfbornstudio.com','sepjac-0y.myshopify.com'].includes(u.hostname) &&
        u.pathname.includes('/uploads/') && /\.txt$/i.test(u.pathname);
    } catch (_) { return false; }
  }
  function isNameItem(item) {
    return item.product_type === 'Personalised Place Names' || /^WB-PN-/.test(item.sku || '') ||
      /^personalised-guest-name-place-settings-/.test(item.handle || '') || Boolean(item.properties && item.properties._wb_place_names);
  }
  function cartCheck(cart) {
    const issues = [], relevant = [];
    for (const [index,item] of (cart.items || []).entries()) {
      if (!isNameItem(item)) continue;
      relevant.push({...item,line:index+1});
      const p = item.properties || {}, r = inspect(itemNames(item));
      const tier = (item.options_with_values || []).find(o => o.name === 'Order size');
      const sizeOption = (item.options_with_values || []).find(o => o.name === 'Name size');
      let reason = r.error;
      if (!reason && sizeOption && p['Name size'] !== sizeOption.value) reason = 'The selected size could not be verified. Please add this guest list again.';
      if (!reason && Number(item.quantity) !== r.count) reason = `${r.count} guest names are attached, but the cart quantity is ${item.quantity}.`;
      if (!reason && (!tier || tier.value !== band(r.count,sizeOption?.value))) reason = 'The pricing band does not match the guest list.';
      if (!reason && (!['v2','v3'].includes(p._wb_place_names) || !p._wb_list_id || p['Spelling confirmation'] !== CONFIRMATION)) reason = 'Please enter and confirm this guest list on the product page.';
      if (!reason && p._wb_place_names === 'v3' && (typeof p[NAMES_KEY] !== 'string' || p['Guest list'] !== r.count+' names supplied')) reason = 'The saved guest-list details could not be verified.';
      if (!reason && p._wb_place_names === 'v3' && !storedFileUrl(p[FILE_KEY])) reason = 'The downloadable guest-list file could not be confirmed. Remove this list and add it again before checkout.';
      if (reason) issues.push({key:item.key,line:index+1,title:item.product_title || item.title || 'Place names',reason});
    }
    return {ok:issues.length===0,issues,items:relevant};
  }
  const api = {names,inspect,band,quotation,payload,textFile,uploadData,itemNames,storedFileUrl,isNameItem,cartCheck,CONFIRMATION,NAMES_KEY,FILE_KEY};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.WolfbornPlaceNames = api;
})(typeof window === 'undefined' ? globalThis : window);
